export function formatDate(date) {
    let returnDate = '';
    if(typeof(Date.parse(date)) === 'number') {
        let dateString = new Date(new Date(date).getTime() + Math.abs(new Date(date).getTimezoneOffset() * 60000)).toLocaleDateString();
        returnDate =  dateString.split("/")[2] + "-" + dateString.split("/")[1] + "-" + dateString.split("/")[0];
    }
    return returnDate;
}
